<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import { mapActions } from 'vuex';
import { DATA_TYPE } from '@/store/modules/cards/constants';
import SimpleDataWithVariation from './models/SimpleDataWithVariation.vue';
import EventBus from '@/utils/event-bus';

export default {
  name: 'OwnedEarnedCollectedUsers',
  components: {
    SimpleDataWithVariation,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getSacListeningWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      const promisses = [
        this.getSacListeningWarroomService({
          itemId: this.itemId,
          servicePath: 'getMonitoringOverviewWithVariation',
          filterType: DATA_TYPE.LISTENING,
        }),
        this.getSacListeningWarroomService({
          itemId: this.itemId,
          servicePath: 'getMonitoringOverviewWithVariation',
          filterType: DATA_TYPE.SAC,
        })];
      Promise.all(
        promisses
      ).then(([responseListening, responseSac]) => {
        this.value = responseListening.total_users + responseSac.total_users;
        this.variation = responseListening.total_users_variation + responseSac.total_users_variation;
        this.rawVariation = responseListening.total_users_variation + responseSac.total_users_variation;
        this.comparationValue = responseListening.previous_total_users + responseSac.previous_total_users;
        this.requestStatus = 'success';

        if (options?.silentRefresh) {
          EventBus.$emit('updated', { itemId: this.itemId });
        }
      })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
